import SMRestClient from 'lib/SMRestClient';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMReservationResource {
  static postReservation(formData, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/reservations.json" + q;  
    const apiClient = new SMRestClient();
    apiClient.post(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        completion(null, error, xhr);
      });
  }
  
  static updateReservation(id, formData, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/reservations/" + id + ".json" + q;
    const apiClient = new SMRestClient();
    apiClient.patch(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        completion(null, error, xhr);
      });
  }
  
  static getMessages(id, queries, completion){
    queries["per_page"] = queries["per_page"] || 999;
    const q = SMFormatHelper.getUrlArgString(queries);
    const apiClient = new SMRestClient();
    apiClient.get("/1/reservations/" + id + "/messages.json" + q).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        completion(null, error, xhr);
      });
  }
  
  static addGuestCompanion(id, formData, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/users/me/reservations/" + id + "/guest_companions.json" + q;
    const apiClient = new SMRestClient();
    const request = apiClient.post(url, formData);
    request.
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
    return request;
  }
  
}
export default SMReservationResource;



// WEBPACK FOOTER //
// ./app/javascript/resources/SMReservationResource.js